// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bf441e0e","239":"648522a4","453":"ed421a54","732":"cf5b54d7"}[chunkId] + ".chunk.js";
};